import { CSVLink } from "react-csv";
import { h } from "preact";
import { CSSProperties } from "styled-components";
import { useQuery } from "../../hooks/useQuery";
import { StyledButtonExportFile } from "./styled";

interface ICSVButton {
  label: string;
  style?: CSSProperties;
  mobileStyle?: CSSProperties;
  tabletStyle?: CSSProperties;
  isLoading?: boolean;
  forceLoading?: boolean;
  data?: any;
  header?: any;
  fileName: string;
  onPress?(): Promise<void> | boolean | void;
}

export const ButtonCSV = ({
  label,
  style,
  mobileStyle,
  tabletStyle,
  data,
  header,
  fileName,
}: ICSVButton) => {
  const { isMobile, isTablet } = useQuery();

  const s = isMobile ? mobileStyle : isTablet ? tabletStyle : style;
  const CSVLinkComponent = CSVLink as any;
  return (
    <CSVLinkComponent filename={fileName} data={data} headers={header}>
      {
        (
          <StyledButtonExportFile style={s}>{label}</StyledButtonExportFile>
        ) as React.ReactNode
      }
    </CSVLinkComponent>
  );
};
